import { createAsyncIcon } from '../../_factory/createAsyncIcon';

const AsyncPhosphorIconLight = createAsyncIcon(() => import('./PhosphorIconLight'));

export default AsyncPhosphorIconLight;

AsyncPhosphorIconLight.displayName = 'AsyncPhosphorIconLight';
